import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "noFunctionsFound" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "qbe-filter-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.QBEFilterDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false,
    "base-z-index": 4203
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('qbe.filters.temporalFilter')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_DataTable, {
        class: "p-datatable-sm kn-table p-m-4",
        value: _ctx.filters,
        selection: _ctx.selectedFilter,
        "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFilter = $event)),
        selectionMode: "single",
        responsiveLayout: "stack",
        breakpoint: "960px"
      }, {
        empty: _withCtx(() => [
          _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: 'name',
            header: _ctx.$t('common.name'),
            sortable: true
          }, null, 8, ["header"])
        ]),
        _: 1
      }, 8, ["value", "selection"])
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}